import AmplitudeService from 'services/AmplitudeService';

export default {
  install(Vue) {
    Vue.prototype.$tracker = AmplitudeService;
  },
};
